<div class="status-badge" [ngStyle]="hostStyles()">
  <svg
    class="status-flag"
    width="8"
    height="9"
    viewBox="0 0 8 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true">
    <path
      d="M0.5625 0C0.873162 0 1.125 0.251838 1.125 0.5625V8.4375C1.125 8.74818 0.873162 9 0.5625 9C0.251838 9 0 8.74818 0 8.4375V0.5625C0 0.251838 0.251838 0 0.5625 0ZM2.25 0.794532C2.25019 0.444906 2.6316 0.229092 2.93142 0.408984L7.875 3.375L2.93142 6.34104C2.6316 6.52092 2.25019 6.3051 2.25 5.95548V0.794532Z"
      [attr.fill]="colorScheme().text" />
  </svg>
  <span class="status-label" [ngStyle]="labelStyles()">{{ label() }}</span>
</div>
